export class ExaminationModel{
bloodSugarFasting= '';
bloodSugarRandom= '';
cBcHgb= '';
cBcMcH= '';
cBcMcV= '';
cBcPlT= '';
cBcTlc= '';
compcode= '';
dateentry= '2021-01-01';
diftBaso= '';
difteosino= '';
diftlym= '';
diftMono= '';
diftNeu= '';
electroca1= '';
electroca2= '';
electroeSR1hr= '';
electroeSR2hr= '';
electrok= '';
electroNa= '';
kFTScrea= '';
kFTUrea= '';
kFTUricAcid= '';
lFTAlB= '';
lFTAlkPH= '';
lFTAlT_SGPT= '';
lFTAST_SGoT= '';
lFTdBill= '';
lFTGGT= '';
lFTINR= '';
lFTldH= '';
lFTPc= '';
lFTPT= '';
lFTTBill= '';
modifieddate= '2021-01-01';
other1= '';
other2= '';
other3= '';
other4= '';
other5= '';
other6= '';
other7= '';
other8= '';
other9= '';
patientcode= '';
tMarkersAFP= '';
tMarkerscA12_5= '';
tMarkerscA15_3= '';
tMarkerscA19_9= '';
tMarkersceA= '';
tMarkersPSA= '';
paName='';
userId= '';
exattach;

}
